<template>
  <progress-tracker v-bind="$attrs" :steps="steps" />
</template>

<script setup lang="ts">
import ProgressTracker from '@/components/progress-tracker.vue'

const steps = [
  { label: 'Quote Details', value: 'details' },
  { label: 'Items Matching', value: 'matching' },
]
</script>
